import { render, staticRenderFns } from "./online-payment.vue?vue&type=template&id=94cb3680&scoped=true&"
import script from "./online-payment.vue?vue&type=script&lang=js&"
export * from "./online-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cb3680",
  null
  
)

export default component.exports